import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ITsdNote } from '~/types/note/models'

export const {
  getNoteListData: getTsdNoteListData,
  getNoteDataById: getTsdNoteDataById,
  getNoteListDataByParentId: getTsdNoteListDataByTsdId,
} = makeNoteMockData<ITsdNote>({
  entityName: 'tsd',
  storageKeyPrefix: 'tsd',
})
